import {useIntl} from "react-intl";
import type {LocationSuggestion} from "@/api/apiClient";
import {formatMoney} from "@/utils/money";
import {getPlaceIcon} from "../utils/icons";
import styles from "./LocationSuggestionItem.module.css";

type LocationSuggestionProps = React.ComponentProps<"button"> & {
    suggestion: LocationSuggestion;
};

export function LocationSuggestionItem({suggestion, ...props}: LocationSuggestionProps) {
    const intl = useIntl();

    return (
        <button className={styles.suggestion} {...props}>
            <div>{getPlaceIcon(suggestion.location.address)}</div>
            <div className={styles.addressContainer}>
                <div className={styles.addressPrimary}>
                    {suggestion.location.address.split(",").at(0)}
                </div>
                <div className={styles.addressSecondary}>
                    {suggestion.location.address.split(",").slice(1).join(",")}
                </div>
            </div>
            {suggestion.price && (
                <div className={styles.price}>{formatMoney(suggestion.price, intl)}</div>
            )}
        </button>
    );
}
